export function getLimitedStr(str, len) {
    if (typeof str !== 'string' || !str.length) {
        return str;
    }
    // 英文字符算1个，汉字算2个
    let newLength = 0;
    let newStr = '';
    const chineseRegex = /[^\x00-\xff]/g;
    let singleChar = '';
    for (let i = 0; i < str.length; i++) {
        singleChar = str.charAt(i).toString();
        if (singleChar.match(chineseRegex) !== null) {
            newLength += 2;
        } else {
            newLength++;
        }
        if (newLength > len) {
            break;
        }
        newStr += singleChar;
    }
    if (newLength > len) {
        newStr += '...';
    }
    return newStr;
}
